(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Nmatoken', Nmatoken);

    Nmatoken.$inject = ['$resource'];

    function Nmatoken ($resource) {
        var resourceUrl =  'api/nmatokens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
